var React = require('react');
var ReactNative = require('react-native');

var Animated = require('./wrappers/Animated')
var Globals = require('./Globals');
var ModelConstants = require('./constants/ModelConstants.js');
var { BlurView, VibrancyView } = require('./wrappers/react-native-blur-wrapper');//require('./wrappers/react-native-blur-wrapper');
var ReUpText = require('./ReUpText');
var ReUpButton = require('./ReUpButton');
var ReUpIconButton = require('./ReUpIconButton');
var ReUpImage = require('./ReUpImage');
var RNFS = require('./wrappers/react-native-fs');
var PlatformConstants = require('./constants/PlatformConstants');

var {
  AppRegistry,
  StyleSheet,
  Text,
  View,
  Image,
  ScrollView,
  Platform,
  Keyboard,
  ListView
} = ReactNative;

var Tutorial = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      appManager : null,
      additionalPages : [],
      shouldShowCloseButton : true,
      useInterstitialFlow : false,
      tutorialDidFinish : null
    }
  },

  getInitialState : function()
  {
    const ds = new ListView.DataSource({rowHasChanged: (r1, r2) => r1 !== r2});
    return {
      layout : this.props.initialLayout,
      pages: [],
      currentPageIndex:0,
      currentPageOffset:new Animated.Value(0),
      newImageOpacity: new Animated.Value(0),
      dataSource: ds.cloneWithRows([
        'John', 'Joel', 'James', 'Jimmy', 'Jackson', 'Jillian', 'Julie', 'Devin'
      ]),
      scrollEnabled:true,
      cardHeight:-1,
      additionalPages:typeof this.props.extras !== 'undefined' && typeof this.props.extras.additionalPages !== 'undefined' ? this.props.extras.additionalPages : [],
      opacity:new Animated.Value(0),
      shouldShowPageUI:true
    }
  },

  setAdditionalPages : function(additionalPages, additionalPageDatas)
  {
    this.setState({additionalPages, additionalPageDatas})
  },

  componentDidMount : function()
  {
    this._didMount = true;
    var appManager = this.props.appManager;
    var locManager = appManager.getLocalizationManager();
    var date = (new Date()).getTime();
    appManager.setVariable(appManager.TUTORIAL_LAST_VIEWED, date, function()
    {
    })
    var addCredit = null;
    var feedNotLoggedIn = null;
    var menuOut = null;
    var rewards = null;
    var useCredit = null;
    var earnPoints = null;

    var thisThing = this;

    appManager.doesResourceExist("Tutorial/iPhone6Plus-AddCredit.png", function(exists)
    {
      if( exists ) addCredit = PlatformConstants.resourcesDirectory + "/Tutorial/iPhone6Plus-AddCredit.png";
      appManager.doesResourceExist("Tutorial/iPhone6Plus-EarnPoints.png", function(exists)
      {
        if( exists ) earnPoints = PlatformConstants.resourcesDirectory + "/Tutorial/iPhone6Plus-EarnPoints.png";
        appManager.doesResourceExist("Tutorial/iPhone6Plus-FeedUpNotLoggedIn.png", function(exists)
        {
          if( exists ) feedNotLoggedIn = PlatformConstants.resourcesDirectory + "/Tutorial/iPhone6Plus-FeedUpNotLoggedIn.png";
          appManager.doesResourceExist("Tutorial/iPhone6Plus-MenuOut.png", function(exists)
          {
            if( exists ) menuOut = PlatformConstants.resourcesDirectory + "/Tutorial/iPhone6Plus-MenuOut.png";
            appManager.doesResourceExist("Tutorial/iPhone6Plus-Rewards.png", function(exists)
            {
              if( exists ) rewards = PlatformConstants.resourcesDirectory + "/Tutorial/iPhone6Plus-Rewards.png";
              appManager.doesResourceExist("Tutorial/iPhone6Plus-UseCredit.png", function(exists)
              {
                if( exists ) useCredit = PlatformConstants.resourcesDirectory + "/Tutorial/iPhone6Plus-UseCredit.png";

                var addCreditFeature = appManager.getFeatureForName("AddCredit");
                var rewardsFeature = appManager.getFeatureForName("Rewards");
                var rewardsCampaignsFeature = appManager.getFeatureForName("RewardsCampaigns");
                var useCreditFeature = appManager.getFeatureForName("UseCredit");

                var introText = locManager.localizedStringForKey("INTRO_TEXT_ONE");
                if( typeof addCreditFeature !== 'undefined' ) introText += " " + locManager.localizedStringForKey("INTRO_ADD_CREDIT");
                if( typeof rewardsCampaignsFeature !== 'undefined' ) introText += " " + locManager.localizedStringForKeyAndParams("INTRO_REWARDS", [rewardsCampaignsFeature.data.title]);
                else if( typeof rewardsFeature !== 'undefined' ) introText += " " + locManager.localizedStringForKeyAndParams("INTRO_REWARDS", [rewardsFeature.data.title]);

                var pages = [];

                pages.push({title:thisThing.props.appManager.appNameLong, body:introText, image:PlatformConstants.resourcesDirectory + '/App/Splash.png', button:"Tell me more..."});

                // if( feedNotLoggedIn != null )
                // {
                //   pages.push({title:"Join Up", body:"Create an account or log into the app to experience all its features.", image:feedNotLoggedIn, button:"Next..."});
                // }

                // if( menuOut != null )
                // {
                //   pages.push({title:"The Menu", body:"To navigate, open up the menu by tapping the icon on the top left.", image:menuOut, button:"I can do that..."});
                // }

                // if( addCredit != null && typeof addCreditFeature !== 'undefined' )
                // {
                //   pages.push({title:addCreditFeature.data.title, body:"Select the " + addCreditFeature.data.title + " option from the menu to add credit to your app.", image:addCredit, button:"Sounds good..."});
                // }

                if( useCredit != null && typeof useCreditFeature !== 'undefined' )
                {
                  pages.push({title:useCreditFeature.data.title, body:locManager.localizedStringForKeyAndParams("INTRO_USE_CREDIT", [useCreditFeature.data.title]), image:useCredit, button:"Okay..."});
                }

                // if( rewards != null && typeof rewardsFeature !== 'undefined' )
                // {
                //   pages.push({title:rewardsFeature.data.title, body:"After earning enough points, select the " + rewardsFeature.data.title + " option in the menu to redeem your free reward!", image:rewards, button:"Got it..."});
                // }

                if( earnPoints != null )
                {
                  var earnPointsFeature = appManager.getFeatureForName("EarnPoints");
                  if( typeof earnPointsFeature !== 'undefined' ) pages.push({title:earnPointsFeature.data.title, body:locManager.localizedStringForKeyAndParams("INTRO_EARN_POINTS", [earnPointsFeature.data.title]), image:earnPoints, button:"Points are nice..."});
                }

                if( pages.length > 1 )
                {
                  var settingsFeature = appManager.getFeatureForName("Settings");
                  pages.push({title:locManager.localizedStringForKey("INTRO_FINISHED_TITLE"), body:locManager.localizedStringForKey("INTRO_SETTINGS")});
                }

                var imageOpacities = [];
                for( var i = 0; i < pages.length; i++ )
                {
                  imageOpacities.push(new Animated.Value(0));
                }
                if( thisThing._didMount ) thisThing.setState({pages:pages, imageOpacities:imageOpacities})
              })
            })
          })
        })
      })
    })
  },

  componentWillUnmount : function()
  {
    this._didMount = false;
  },

  fadeIn: function()
  {
    Animated.timing(
      this.state.opacity,
      {
        toValue: 1,
        duration: 100,
      },
    ).start(function()
    {
    });
  },

  getInfoForSkip: function()
  {
    var isAdditionalPage = this.state.pages.length <= this.state.currentPageIndex;
    if( isAdditionalPage && typeof this.props.extras === 'undefined' ) return "";

    var currentPageIndex = this.state.currentPageIndex;
    var indexAndPageString = '';
    if( isAdditionalPage )
    {
      var additionalPageIndex = currentPageIndex - this.state.pages.length;
      var thisAdditionalData = this.props.extras.additionalPageDatas[additionalPageIndex];
      indexAndPageString = currentPageIndex + '-' + thisAdditionalData.data.title;
    }
    else
    {
      var currentPageData = this.state.pages[currentPageIndex];
      indexAndPageString = currentPageIndex + '-' + currentPageData.title;
    }
    return indexAndPageString;
  },

  didUpdate : function(data)
  {
  },

  dismiss : function(completion)
  {
    if( this.props.useInterstitialFlow )
    {
      this.props.tutorialDidFinish(completion);
    }
    else
    {
      this.props.appActions.setCustomAlertShown(false);
    }
  },

  _navButtonCoolDown:false,
  _disableGoNextButton:false,
  goNext: function(completion, isFromButton = false)
  {
    if( this._navButtonCoolDown ) return;
    if( isFromButton && this._disableGoNextButton ) return;

    this._navButtonCoolDown = true;
    setTimeout(()=>this._navButtonCoolDown=false, 300);

    Keyboard.dismiss();
    var thisThing = this;
    var isLastPage = this.state.currentPageIndex >= ((this.state.pages.length-1) + this.state.additionalPages.length);
    var isLastPageBeforeAdditional = this.state.currentPageIndex >= (this.state.pages.length-1);
    if( isLastPageBeforeAdditional ) 
    {
      this._disableGoNextButton = true;
      this.setState({shouldShowPageUI:false});
    }

    if( isLastPage )
    {
      this.dismiss(completion);
    }
    else
    {
      var newCurrentPageIndex = this.state.currentPageIndex+1;
      var xOffset = newCurrentPageIndex * (this.state.layout.width);
      this.refs.scroll.scrollTo({x:xOffset})
      var thisThing = this;
      setTimeout(function()
      {
        thisThing.onScroll(xOffset);
      },150)
    }
  },

  goBack: function()
  {
    if( this._navButtonCoolDown ) return;
    this._navButtonCoolDown = true;
    setTimeout(()=>this._navButtonCoolDown=false, 300);
    
    var thisThing = this;
    var isFirstPage = this.state.currentPageIndex == 0;
    if( isFirstPage )
    {
      // do nothing
    }
    else
    {
      var newCurrentPageIndex = this.state.currentPageIndex-1;
      var xOffset = newCurrentPageIndex * (this.state.layout.width);
      this.refs.scroll.scrollTo({x:xOffset})
      var thisThing = this;
      setTimeout(function()
      {
        thisThing.onScroll(xOffset);
      },150)
    }
  },

  onScroll: function(offset)
  {
    var page = Math.round(offset/(this.state.layout.width))
    if( page != this.state.currentPageIndex )
    {
      this.state.currentPageIndex = page;
      if( this.state.pages.length > this.state.currentPageIndex )
      {
        var activePage = this.state.pages[this.state.currentPageIndex];
        if( typeof activePage.image !== 'undefined' )
        {
          this.refs.image.setImage(activePage.image)
        }
        else
        {
          this.refs.image.setImage(null)
        }
      }
      else
      {
        if( this.state.currentPageIndex >= (this.state.pages.length + this.state.additionalPages.length) ) this.dismiss();
      }
      if( Platform.OS != 'ios' ) this.onMomentumScrollEnd();
      this.setState({currentPageIndex:page});
    }
  },

  onMomentumScrollEnd: function()
  {
    if( this.state.pages.length <= this.state.currentPageIndex )
    {
      console.log("this.setState({scrollEnabled:false})")
      if( this.state.scrollEnabled ) this.setState({scrollEnabled:false});

      var additionalPageIndex = this.state.currentPageIndex - this.state.pages.length;
      if( typeof this.refs["additional"+additionalPageIndex] !== 'undefined' &&
          typeof this.refs["additional"+additionalPageIndex].focus !== 'undefined' )
      {
        this.refs["additional"+additionalPageIndex].focus()
      }

      if( typeof this.props.extras.didShowAdditional !== 'undefined' )
      {
        this.props.extras.didShowAdditional();
      }

      if( typeof this.props.extras !== 'undefined' && typeof this.props.extras.additionalPageDatas !== 'undefined' && this.props.extras.additionalPageDatas.length > additionalPageIndex )
      {
        var featureData = this.props.extras.additionalPageDatas[additionalPageIndex];
        if( typeof this.props.extras.didChangeTitle !== 'undefined' ) this.props.extras.didChangeTitle(featureData.data.title);
        if( this.state.scrollEnabled )
        {
          // thisThing.refs.scroll.scrollTo({x:page*thisThing.state.layout.width})
          // thisThing.state.scrollEnabled = false;
        }
      }
    }
  },

  render: function()
  {
    var thisThing = this;
    var appManager = this.props.appManager;
    var locManager = this.props.appManager.getLocalizationManager();
    var layout = this.state.layout;

    var instructionColor = appManager.getColorForKey("InstructionColor");
    var instructionTitleColor = appManager.getColorForKey("InstructionTitleColor");
    var generalColor = appManager.getColorForKey("GeneralColor");
    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
    var feedCardColor = appManager.getColorForKey("FeedCardColor");
    var feedCardTitleColor = appManager.getColorForKey("FeedCardTitleColor");
    var feedCardBannerColor = appManager.getColorForKey("FeedCardBannerColor");

    var phoneFrameRatio = parseFloat(16 / 9); // (H/W)
    var percentOfWidth = parseFloat(0.6);
    var percentSpeakerWidth = parseFloat(0.17);
    var percentScreenWidth = parseFloat(0.85);
    var phoneScreenRatio = parseFloat(16.0)/parseFloat(9.0);
    var phoneFrameAdditionalHeight = 26;
    var phoneFrameWidth = this.state.layout.width * percentOfWidth;
    var phoneFrameHeight = phoneFrameRatio * phoneFrameWidth + phoneFrameAdditionalHeight;
    var phoneScreenWidth = phoneFrameWidth * percentScreenWidth;
    var phoneScreenHeight = phoneScreenWidth * phoneScreenRatio;
    var phoneSpeakerHeight = 4;
    var phoneSpeakerWidth = phoneFrameWidth * percentSpeakerWidth;

    var tutorialBackgroundColor = Platform.OS === 'ios' ? 'transparent' : 'transparent';

    var activePage = this.state.currentPageIndex < this.state.pages.length ? this.state.pages[this.state.currentPageIndex] : {};
    var index = this.state.currentPageIndex;

    var shouldShowBackArrow = (this.state.currentPageIndex > 0 && this.state.currentPageIndex < this.state.pages.length) && this.state.shouldShowPageUI;
    var shouldShowForwardArrow = (this.state.currentPageIndex < this.state.pages.length) && this.state.shouldShowPageUI;
    var shouldShowPageControl = (this.state.cardHeight > 0 && this.state.currentPageIndex < this.state.pages.length) && this.state.shouldShowPageUI;
// this.state.cardHeight = 0;
    return (
      <Animated.View key={"tutorialContainer"} style={{opacity:this.state.opacity, flexDirection:'column', width:this.state.layout.width, height:this.state.layout.height, backgroundColor:tutorialBackgroundColor}}>
        {
          this.state.cardHeight > 0 ?
            <View key={"tutorial"} style={{ backgroundColor:'transparent', marginLeft:0, flexDirection:'row', width:this.state.layout.width, height:this.state.layout.height, paddingTop:this.state.cardHeight + (this.props.shouldShowCloseButton ? Globals.ACTION_BAR_HEIGHT : Globals.STATUS_BAR_HEIGHT)}}>
              <View pointerEvents='none' style={{width:layout.width, height:layout.height-(this.props.shouldShowCloseButton ? Globals.ACTION_BAR_HEIGHT : Globals.STATUS_BAR_HEIGHT)}}>
                <View key={"imageFrame"} style={{flex:1, flexDirection:'row', marginTop:10}}>
                  <View style={{flex:1}} />
                  <View key={"phoneFrame"} style={{flexDirection:'column', elevation:2, width:phoneFrameWidth, paddingTop:phoneFrameWidth/24, height:phoneFrameHeight, borderRadius:25, backgroundColor:'white'}}
                    shadowColor="black"
                    shadowRadius={2}
                    shadowOffset={{width:0, height:2}}
                    shadowOpacity={0.7} >
                    <View style={{flexDirection:'row', flex:1, alignItems:'center'}}>
                      <View style={{flex:1}}>
                        <View style={{width:phoneFrameWidth/24, height:phoneFrameWidth/24, borderRadius:100000, backgroundColor:'grey', alignSelf:'flex-end'}} />
                      </View>
                      <View style={{flex:0, marginHorizontal:phoneFrameWidth/20, flexDirection:'column'}}>
                        <View style={{flex:1, flexDirection:'column', alignItems:'center'}}>
                          <View style={{flex:1}}/>
                          <View style={{width:phoneFrameWidth/36, height:phoneFrameWidth/36, borderRadius:100000, backgroundColor:'grey', marginBottom:phoneSpeakerHeight*1.5}} />
                        </View>
                        <View style={{height:phoneSpeakerHeight, width:phoneSpeakerWidth, borderRadius:100000, backgroundColor:'grey', alignSelf:'flex-end'}} />
                        <View style={{flex:1}} />
                      </View>
                      <View style={{flex:1}} />
                    </View>
                    <View key={"phoneFrame2"} style={{flex:-1, flexDirection:'row'}}>
                      <View style={{flex:1}} />
                      <View key={"phoneFrame3"} style={{width:phoneScreenWidth+6, height:phoneScreenHeight+6, borderRadius:2, borderWidth:3, borderColor:'grey'}}>
                        <ReUpImage ref={"image"} key={"image"} backgroundImage={PlatformConstants.resourcesDirectory + '/App/Splash.png'} style={{width:phoneScreenWidth, height:phoneScreenHeight, position:'absolute', opacity:1}}/>
                      </View>
                      <View style={{flex:1}} />
                    </View>
                    <View style={{flex:1, alignItems:'center', justifyContent:'center'}}>
                      <View style={{width:phoneFrameWidth/8, height:phoneFrameWidth/8, borderRadius:1000, backgroundColor:"#EEE"}} />
                    </View>
                  </View>
                  <View style={{flex:1}} />
                </View>
                <View style={{alignItems:'center'}}>
                  <View style={{flex:1}} />
                  <View style={{backgroundColor:generalColor, padding:4, alignItems:'center'}}>

                  </View>
                  <View style={{flex:1}} />
                </View>
              </View>
            </View>
          : null
        }
        <ScrollView ref="scroll" key="scroll"
        bounces={false} horizontal={true} showsHorizontalScrollIndicator={false}
        scrollEnabled={this.state.scrollEnabled}
        keyboardShouldPersistTaps={true}
        pagingEnabled={true} style={{backgroundColor:'transparent', position:'absolute', left:0, right:0, top:0, bottom:0}}
          onScroll={(info) =>
          {
            thisThing.onScroll(info.nativeEvent.contentOffset.x);
          }}
          scrollEventThrottle={200}
          onMomentumScrollEnd={() =>
          {
            thisThing.onMomentumScrollEnd();
          }}
          >
          <View style={{flexDirection:'column', backgroundColor:'transparent'}}>
            <View shadowRadius={2}
              style={{backgroundColor:'transparent', flexDirection:'row', marginTop:this.props.shouldShowCloseButton ? Globals.ACTION_BAR_HEIGHT : 0}} onLayout={(e)=>{if( e.nativeEvent.layout.height > 0 && thisThing.state.cardHeight != e.nativeEvent.layout.height ) {thisThing.setState({cardHeight:e.nativeEvent.layout.height}); thisThing.fadeIn()}}}>
            {
              this.state.pages.map(function(page, pageIndex)
              {
                return <View key={"page"+pageIndex} style={{width:thisThing.state.layout.width - 8, marginHorizontal:4, backgroundColor:feedCardColor, borderRadius:2}}>
                  <View style={{paddingBottom:20, paddingHorizontal:10, paddingTop:8}}>
                  {
                    typeof page.title !== 'undefined' ?
                      <View style={{flexDirection:'row'}}>
                        <View style={{flex:1}} />
                        <View style={{flexWrap: 'wrap', flex:-1}}>
                          <ReUpText appManager={appManager} isTitle={true} style={{margin:4, textAlign:'center', color:feedCardTitleColor}}>
                            {page.title}
                          </ReUpText>
                        </View>
                        <View style={{flex:1}} />
                      </View>
                    : null
                  }
                  {
                    typeof page.body !== 'undefined' ?
                      <ReUpText appManager={appManager} style={{margin:4, textAlign:'center', color:feedCardTitleColor}}>
                        {page.body}
                      </ReUpText>
                    : null
                  }
                  </View>
                </View>
              })
            }
            </View>
            <View style={{flex:1}} />
          </View>
          {
            thisThing.state.additionalPages.map(function(component, index)
            {
              var currentPageIndex = thisThing.state.currentPageIndex;
              var additionalPageIndex = currentPageIndex - thisThing.state.pages.length;
              if( index > additionalPageIndex+1 ) return null;

              var clonedComponent = React.cloneElement(component, {ref:"additional"+index});
              return (<View key={"additional"+index} style={{width:thisThing.state.layout.width, height:thisThing.state.layout.height + Globals.ACTION_BAR_HEIGHT, marginTop: -Globals.ACTION_BAR_HEIGHT}}>
                  {clonedComponent}
                </View>)
            })
          }
          <View key={"buffer"} style={{width:thisThing.state.layout.width, height:thisThing.state.layout.height + Globals.ACTION_BAR_HEIGHT, marginTop: -Globals.ACTION_BAR_HEIGHT}} />
        </ScrollView>
        {
          this.props.shouldShowCloseButton ?
            <View style={{position:'absolute', top:0, left:0, right:0, flexDirection:'row', height:Globals.ACTION_BAR_HEIGHT, paddingHorizontal:10, paddingTop:Globals.STATUS_BAR_HEIGHT}}>
              <View style={{flex:1}}/>
              <View style={{backgroundColor:appManager.getColorForKey("GeneralColor", 1), borderRadius:1000000, alignSelf:'center'}}>
                <ReUpIconButton iconName={"times"} type={6} appManager={appManager} onPress={()=>{this.dismiss()}} />
              </View>
            </View>
          : null
        }
        <View style={{position:'absolute', top:this.state.cardHeight - 14 + (this.props.shouldShowCloseButton ? Globals.ACTION_BAR_HEIGHT : 0), left:0, right:0, flexDirection:'row', paddingBottom:10, justifyContent:'center'}}>
        {
          shouldShowPageControl ?
            thisThing.state.pages.map(function(page, index)
            {
              if( index == thisThing.state.currentPageIndex )
              {
                return <View key={"page"+index} style={{marginHorizontal:5, width:8, height:8, borderRadius:999, backgroundColor:feedCardBannerColor,}} />
              }
              return <View key={"page"+index} style={{marginHorizontal:5, width:8, height:8, borderRadius:999, backgroundColor:feedCardTitleColor}} />
            })
          : null
        }
        </View>
        <View pointerEvents={Platform.OS != 'ios' ? 'box-only' : "auto"} onStartShouldSetResponder={()=>{if( Platform.OS != 'ios' ) thisThing.goBack(); return shouldShowBackArrow}} style={{position:'absolute', left:0, top:(thisThing.state.layout.height - 30 - thisThing.state.cardHeight)/2 - 50 + thisThing.state.cardHeight, padding:10, flexDirection:'row', alignItems:'center'}}>
        {
          shouldShowBackArrow ?
            <ReUpIconButton iconName={"angle-left"} appManager={appManager} type={1} onPress={function()
              {
                thisThing.goBack();
              }} />
          : null
        }
        </View>
        <View pointerEvents={Platform.OS != 'ios' ? 'box-only' : "auto"} onStartShouldSetResponder={()=>{if( Platform.OS != 'ios' ) thisThing.goNext(); return shouldShowForwardArrow}} style={{position:'absolute', right:0, width:60, height:60, top:(thisThing.state.layout.height - 30 - thisThing.state.cardHeight)/2 - 50 + thisThing.state.cardHeight, padding:10, flexDirection:'row', alignItems:'center'}}>
        {
          shouldShowForwardArrow ?
            <ReUpIconButton iconName={"angle-right"} appManager={appManager} type={0} onPress={function()
              {
                thisThing.goNext(()=>{}, true);
              }} />
          : null
        }
        </View>
      </Animated.View>
    );
  }
});

var styles = StyleSheet.create({
  container:{
    flex: 1,
    justifyContent: 'center',
    flexDirection:'row',
    alignItems:'stretch'
  },
  blurStyle:{
    flex:1,
    justifyContent: 'center',
    alignItems:'stretch',
  }
});

Tutorial.getCards = function(featureData, appActions, data)
{
  if( typeof data.Transactions !== 'undefined' && data.Transactions.length > 1 ) return [];

  var appManager = appActions._appManager;
  var didSelect = function() {appActions.requestFeatureName("Tutorial", {forceShow:true})};
  var iconName = featureData.data.icon.replace("fa-", "")
  return [{
    didSelect : didSelect,
    title : featureData.data.title,
    body1 : featureData.data.tip,
    icon : iconName,
    cardType : 0,
    sortOrder : 2,
  }];
}

Tutorial.customNavigation = function(featureData, appActions, featureBuilder, layout, extras)
{
  if( appActions._appManager.skipTutorial ) return;
  // if( featureData.data.tutorialImages == "TUTORIAL_IMAGE_LIST" ) return;

  appActions._appManager.getVariable(appActions._appManager.TUTORIAL_LAST_VIEWED, function(date)
  {
    if( date == null || extras.forceShow == true )
    {
      appActions.setCustomAlertShown(true,featureBuilder.featureForData(featureData, layout, appActions._appManager, {}, extras), function(){}, true);
    }
  })
}

Tutorial.dataDependencies = [];

module.exports = Tutorial;



// WEBPACK FOOTER //
// ./src/Tutorial.js